export default {
  getSoftSaleStockItemAudit: (state) => state.softSaleStockItemAudit,
};
